import { makeAutoObservable } from "mobx";

import { NotificationReportCommand, NotificationService } from "api";
import { NotificationGlobalStore } from "..";
import { MessageStore } from "stores/MessageStore";

export class NotificationsStore {
  private _notificationService: NotificationService;

  initalized: boolean = false;

  messageStore: MessageStore;
  notificationGlobalStore: NotificationGlobalStore;

  constructor() {
    makeAutoObservable(this);

    this._notificationService = new NotificationService();
    this.notificationGlobalStore = new NotificationGlobalStore();
    this.messageStore = new MessageStore();
  }

  init = async () => {
    try {
      await Promise.all([this.loadActionNotifications()]);

      this.initalized = true;
    } catch {
      this.messageStore.errorMessage(
        "There was a problem loading notifications. Please try again. If this problem persists, please contact support."
      );
    }
  };

  loadActionNotifications = async () => {
    const response = await this._notificationService.getActiveNotifications();

    if (!response.success) throw response.message;
    this.notificationGlobalStore.activeNotifications = response.notifications;
  };

  loadNotificationsReport = async (requestData: NotificationReportCommand) => {
    await this._notificationService.loadNotificationsReport(requestData);
  };
}

export default new NotificationsStore();
